<template>
    <binary
        v-bind:expression="expression"
        v-bind:path="path"
        v-bind:operator="operator">
        <template v-slot:stackedOperator>
            <div
                style="height: 2px"
                class="bg-dark align-self-stretch stacked-divide" />
        </template>
    </binary>
</template>
<script>
    import binary from "./binary.vue";
    export default {
        components: { binary },
        props: {
            expression: { type: Object, required: true },
            path: {
                type: Array,
                required: false,
                default: function () {
                    return [];
                }
            }
        },
        data() {
            return { operator: "\u00f7" };
        }
    };
</script>
